export default {"src":"https://images-cdn.curipod.com/d-aa3c45e5/_next/static/media/gwinnett_county.1b5c2fe8.svg","height":86,"width":267};